<template>
    <div class="auto-add-que xy-between al-str">
        <div class="left">
            <div class="title xy-between">
                输入区
                <div class="font-size14 c-0C95FD pointer">
                    <span
                        class="mr-10"
                        @click="
                            (dialogVisible = true), (dialogTitle = '输入示例')
                        "
                        >输入示例</span
                    >
                    <span
                        @click="
                            (dialogVisible = true), (dialogTitle = '输入规范')
                        "
                        >输入规范</span
                    >
                </div>
            </div>
            <div
                class="input-content box"
                contenteditable
                @input="inputRule"
                @paste="imgFileFetch"
                ref="inputBox"
            ></div>
        </div>
        <div class="right auto-grow">
            <div class="title">检查区</div>
            <div class="show-content box">
                <auto-que-item
                    v-for="(item, index) in queData"
                    :key="index"
                    :que-data="item"
                ></auto-que-item>
                <div v-if="userInput && queData.length === 0" class="err-box">
                    请输入题干
                </div>
            </div>
        </div>
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="50%"
        >
            <div
                class="p-martop"
                v-html="
                    dialogTitle === '输入示例' ? exampleContent : rulesContent
                "
            ></div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>
<script>
import AutoQueItem from "./AutoQueItem.vue";
import { uploadFile } from "@/api/manage.js";
export default {
    components: { AutoQueItem },
    props: {},
    data() {
        return {
            dialogTitle: "",
            dialogVisible: false,
            userInput: "",
            queData: [],
            pasteLoading: false,
            exampleContent:
                "<p style='color:#ff9197' class='font-medium'>单选题</p><p>1、大海是什么颜色的?<p><p>A、绿色</p><p>B、蓝色</p><p>C、红色</p><p>D、粉色</p><p>答案：B</p><p>解析:蓝色</p><p>难度:简单</p><br /><p style='color:#408AF2' class='font-medium'>多选题</p><p>2、请选择正确的夏天应该穿的衣服?<p><p>A、裙子</p><p>B、棉袄</p><p>C、短袖</p><p>D、秋裤</p><p>E、毛衣</p><p>答案:A、C</p><p>解析:请结合生活实际</p><p>难度:简单</p><br /><p style='color:#5ac325' class='font-medium'>填空题<p>3、床前明月光的后三句诗词()、()、()</p>答案:疑似地上霜|举头望明月；低头思故乡</p><p>解析:《静夜思》</p><p>难度:普通</p><br /><p style='color:#a45ae6' class='font-medium'>判断题<p>4、新青年刊登的第一篇白话文是《狂人日记》吗</p><p>答案：正确</p><p>难度：困难</p><p>解析：请查询中国近代史</p><br /><p style='color:#FFBF00' class='font-medium'>简答题<p>5、请简述一下你对当今中国美好未来的期许</p><p>答案：自由发挥</p><p>解析：(选填)</p>",
            rulesContent:
                "<p>1、所有题型标号支持1.或1、两种格式。</p><p>2、所有题型必须含有 “ 答案：”字段，且不能为空。</p><p>3、所有题型 “ 解析：” 字段非必需，没有可不填。</p><p>4、所有题型必须含有 “ 难度：”字段，且不能为空，如若输入题型未设置难度将会设置为默认难度<span class='c-256CF4'>普通</span>。</p><p>5、所有题型支持插入图片(填空题答案不允许为图片)。</p><p>6、选择题最少支持2个选项A,B，最多支持8个选项A,B,C,D,E,F,G,H且按照顺序使用。</p><p>7、选择题A-H这些选项号与内容之间要用、 . ：:(顿号、英文句号、中文或英文分号)四种中任意一种符号分开。</p><p>8、多选题答案请至少输入两个答案，且选项答案请用、.，,(顿号、英文句号、中文或英文逗号)四种中任意一种符号分开。</p><p>9、判断题答案支持 “错误”，“正确” 或者 “错”，“对”。</p><p>10、填空题仅支持题目中出现括号()、（）或_三种符号。</p><p>11、填空题目里的多个填空答案要用 | ；;三种中任意一种符号分开，单个答案不用添加。</p><p>12、填空题的填空数需与答案数一致。</p>",
        };
    },
    computed: {
        canAdd() {
            return this.queData.length > 0 && this.queData.every(el => el._checked)
        }
    },
    methods: {
        imgFileFetch(e) {
            // console.log(e);
            const files = e.clipboardData.files;
            if (files.length > 1) {
                this.$message.warning("不支持复制多个文件");
                e.preventDefault();
                return;
            }
            const selection = window.getSelection();
            const parent = selection.getRangeAt(0);
            if (files.length > 0) {
                const file = files[0];
                if (file.type.startsWith("image/")) {
                    this.pasteLoading = true;
                    uploadFile({ file }, (p) => {
                        this.pasteProgress = true;
                    })
                        .then(async (url) => {
                            this.pasteLoading = false;
                            if (!selection.rangeCount) return false;
                            selection.deleteFromDocument();
                            const img = document.createElement("img");
                            const uid = "i-" + new Date().getTime();
                            img.src = url;
                            img.style.display = "block";
                            img.dataset.uid = uid;
                            parent.insertNode(img);
                            const div = document.createElement("div");
                            div.innerText = "${" + url + "}";
                            div.style.position = "absolute";
                            div.style.opacity = "0";
                            div.id = uid;
                            parent.insertNode(div);
                            setTimeout(() => {
                                parent.setStartAfter(img);
                                this.observer(img.parentElement);
                                this.inputRule();
                            }, 60);
                        })
                        .finally(() => {
                            this.pasteProgress = false;
                        });
                    e.preventDefault();
                    return true;
                }
            }

            this.inputRule();
        },
        observer(parent) {
            const that = this;
            const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (
                        mutation.removedNodes &&
                        mutation.removedNodes.length > 0
                    ) {
                        mutation.removedNodes.forEach((dom) => {
                            if (dom.tagName === "IMG") {
                                const uid = dom.dataset.uid;
                                const div = document.getElementById(uid);
                                div.parentElement.removeChild(div);
                                observer.disconnect();
                                setTimeout(() => that.inputRule(), 60);
                            }
                        });
                    }
                });
            });
            let config = {
                attributes: true,
                childList: true,
                characterData: true,
            };
            observer.observe(parent, config);
        },
        clear() {
            this.$refs.inputBox.innerText = "";
            this.userInput = ""
            this.queData = []
        },
        inputRule(text) {
            let question = [];
            let questionItem;
            let lastInput;
            const dom = this.$refs.inputBox;
            const innerText = this.trimSpec(dom.innerText.split(/\n+/));
            // console.log("innerText:", dom.innerText);
            const tpVlProcess = (tp) => {
                if (!tp) return "";
                let result = "";
                if (tp.startsWith("${") && tp.endsWith("}")) {
                    result = `<br /><img src="${tp.substr(
                        2,
                        tp.length - 3
                    )}"></img>`;
                } else {
                    result = `<p>${tp}</p>`;
                }
                return result;
            };
            for (let i in innerText) {
                let value = innerText[i].substring(3);
                // console.log("value:", value);
                if (innerText[i]) {
                    if (!/^(\d+[、.])/g.test(innerText[i]) && !questionItem) {
                        this.userInput = dom.innerHTML;
                        continue;
                    }
                    if (/^(\d+[、.])/g.test(innerText[i])) {
                        // 题干
                        lastInput = "stem";
                        if (
                            questionItem &&
                            Object.keys(questionItem).length >= 4
                        ) {
                            questionItem = null;
                        }

                        if (!questionItem) {
                            let index1 = !innerText[i].includes("、")
                                ? 999
                                : innerText[i].indexOf("、");
                            let index2 = !innerText[i].includes(".")
                                ? 999
                                : innerText[i].indexOf(".");
                            let _index = index1 < index2 ? index1 : index2;
                            // console.log("index,index1，index2", _index, index1, index2)
                            questionItem = {
                                qId: innerText[i].substring(0, _index),
                                SubjectType: 5,
                                Hardlevel: 2,
                                Content: tpVlProcess(
                                    innerText[i].substring(1 + _index)
                                ),
                            };

                            question.push(questionItem);
                        }
                    } else if (Object.keys(questionItem).length >= 4) {
                        if (
                            /[A-H][.|、|:|：]/g.test(
                                innerText[i].substring(0, 2)
                            )
                        ) {
                            // 选项
                            lastInput = "AnswerList";
                            questionItem.SubjectType = 1;
                            if (!questionItem.AnswerList) {
                                questionItem.AnswerList = [];
                            }
                            let item = {
                                Option: innerText[i].substring(0, 1),
                                RankNum: questionItem.AnswerList.length + 1,
                                IsRight: 0,
                                Content: tpVlProcess(innerText[i].substring(2)),
                            };
                            questionItem.AnswerList.push(item);
                        } else if (/答案：|答案:/g.test(innerText[i])) {
                            // 答案
                            lastInput = "Answer";
                            const work = () => {
                                if (questionItem.AnswerList) {
                                    let ans =
                                        questionItem.SubjectType === 1
                                            ? [questionItem.Answer]
                                            : questionItem.Answer;

                                    questionItem.AnswerList.forEach((v) => {
                                        v.IsRight = ans.includes(v.Option)
                                            ? 1
                                            : 0;
                                    });
                                }
                            };
                            if (value.length <= 2 && /[A-H]/g.test(value)) {
                                questionItem.Answer = value;
                                questionItem.SubjectType = 1;
                                work();
                            } else if (
                                value.length > 2 &&
                                /[A-H][、,，.]/.test(value)
                            ) {
                                questionItem.SubjectType = 2;
                                questionItem.Answer = value
                                    .split(/[、,，.]/)
                                    .filter((v) => v);
                                work();
                                // console.log("mupArr:", mupArr)
                            } else if (
                                ["正确", "错误", "对", "错"].includes(value)
                            ) {
                                questionItem.AnswerList = [
                                    {
                                        Option: "A",
                                        RankNum: 1,
                                        IsRight: 0,
                                        Content: "正确",
                                    },
                                    {
                                        Option: "B",
                                        RankNum: 2,
                                        IsRight: 0,
                                        Content: "错误",
                                    },
                                ];
                                questionItem.SubjectType = 4;

                                if (["正确", "对"].includes(value)) {
                                    questionItem.Answer = 1;
                                    questionItem.AnswerList[0].IsRight = 1;
                                } else {
                                    questionItem.Answer = 0;
                                    questionItem.AnswerList[1].IsRight = 1;
                                }
                            } else if (
                                /(（\s*）|\(\s*\)|_)+/i.test(
                                    questionItem.Content
                                ) &&
                                !questionItem.AnswerList
                            ) {
                                questionItem.SubjectType = 3;
                                let fillAns = value
                                    .split(/[|;；]/)
                                    .filter((v) => v);
                                questionItem.Answer = fillAns;
                                questionItem.AnswerList = [];
                                for (let i = 0; i < fillAns.length; i++) {
                                    questionItem.AnswerList.push({
                                        RankNum:
                                            questionItem.AnswerList.length + 1,
                                        IsRight: 1,
                                        Content: fillAns[i],
                                    });
                                }
                            } else {
                                questionItem.Answer = tpVlProcess(value);
                            }
                        } else if (/解析：|解析:/g.test(innerText[i])) {
                            // 解析
                            lastInput = "Analysis";
                            questionItem.Analysis = tpVlProcess(value);
                        } else if (/难度：|难度:/g.test(innerText[i])) {
                            // 难度
                            questionItem.Hardlevel =
                                value === "简单" ? 1 : value === "普通" ? 2 : 3;
                        } else if (lastInput) {
                            // console.log("lastInput:", lastInput);
                            const nowLine = innerText[i];
                            if (lastInput === "stem") {
                                const stem = nowLine || "";
                                questionItem.Content += tpVlProcess(stem);
                            } else if (lastInput === "Analysis") {
                                const analysis = nowLine || "";
                                questionItem.Analysis += tpVlProcess(analysis);
                            } else if (lastInput === "Answer") {
                                if (questionItem.SubjectType === 5) {
                                    questionItem.Answer += tpVlProcess(nowLine);
                                }
                            } else if (lastInput === "AnswerList") {
                                const old =
                                    questionItem.AnswerList[
                                        questionItem.AnswerList.length - 1
                                    ].Content;

                                questionItem.AnswerList[
                                    questionItem.AnswerList.length - 1
                                ].Content = old + tpVlProcess(nowLine);
                            }
                        }
                    }
                }

                this.queData =
                    question.length > 0 || !this.userInput ? question : [];
            }
        },
        // 去除每一行的前后空格
        trimSpec(lines) {
            return lines.map(el => {
                return el.trim()
            })
        }
    },
};
</script>

<style lang="less" scoped>
.auto-add-que::v-deep {
    .left,
    .right {
        .title {
            background: #f4f5f6;
            height: 60px;
            padding: 0 30px;
            font-size: 16px;
            line-height: 60px;
        }
        .box {
            border: 1px solid #e5e8ec;
            padding: 20px;
            min-height: 600px;
        }
    }
    .left {
        width: 379px;
        margin-right: 20px;
        .input-content {
            height: calc(100% - 100px);
            p {
                margin: 0;
            }
            img {
                width: 120px;
            }
        }
    }
    .right {
        .err-box {
            background: red;
            line-height: 30px;
            color: white;
            padding-left: 5px;
        }
    }
    .el-dialog__body {
        p {
            margin: 0;
        }
    }
    .p-martop{
        p{
            margin-top: 0.1rem;
        }
        :first-child{
            margin-top: 0;
        }
    }
}
.show-content {
    ::v-deep p {
        display: inline;
    }
}
</style>
